(() => {
  const CUSTOM_SIZE_VALUE = "custom size";

  const normalize = (value) => (value || "").toString().trim().toLowerCase();

  const labelForInput = (input) => {
    if (!input?.id) return "";
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    return normalize(label?.textContent);
  };

  const variantHasCustomSize = (variant) => {
    if (!variant) return false;

    const optionValues = [
      ...(Array.isArray(variant.options) ? variant.options : []),
      variant.option1,
      variant.option2,
      variant.option3,
      variant.title,
      variant.public_title,
    ];

    return optionValues.some((value) => normalize(value) === CUSTOM_SIZE_VALUE);
  };

  const isCustomSizeSelected = (root = document, variant) => {
    if (variantHasCustomSize(variant)) return true;

    const checkedOptions = root.querySelectorAll(
      'variant-picker input[data-option-position]:checked, form[action*="/cart/add"] input[data-option-position]:checked'
    );

    return Array.from(checkedOptions).some((input) => {
      const optionName = normalize(input.getAttribute("data-option-name"));
      if (optionName === CUSTOM_SIZE_VALUE) return true;
      if (normalize(input.value) === CUSTOM_SIZE_VALUE) return true;
      return labelForInput(input) === CUSTOM_SIZE_VALUE;
    });
  };

  const syncCustomSizeFields = (root = document, variant) => {
    const fields = root.querySelectorAll("[data-custom-size-field]");
    if (!fields.length) return;

    const show = isCustomSizeSelected(root, variant);

    fields.forEach((field) => {
      field.hidden = !show;

      field.querySelectorAll("input, textarea, select").forEach((input) => {
        input.disabled = !show;
        if (!show) {
          if (input.type === "checkbox" || input.type === "radio") {
            input.checked = false;
          } else {
            input.value = "";
          }
        }
      });
    });
  };

  const init = () => {
    syncCustomSizeFields();

    document.addEventListener("variant:change", (event) => {
      syncCustomSizeFields(document, event.detail?.variant);
    });

    document.addEventListener("change", (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (!target.matches("input[data-option-position]")) return;
      syncCustomSizeFields();
    });

    document.addEventListener("product:rerender", () => {
      requestAnimationFrame(() => syncCustomSizeFields());
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
